import React from 'react'
import ManageContent from './ManageContent'

export default function ManagePage () {
  return (
    <div className='helpPage mobile'>
      <ManageContent isMobile={true} />
    </div>
  )
}
